import { render, staticRenderFns } from "./MemcachedCacheConfig.vue?vue&type=template&id=38e084a5&scoped=true&"
import script from "./MemcachedCacheConfig.vue?vue&type=script&lang=js&"
export * from "./MemcachedCacheConfig.vue?vue&type=script&lang=js&"
import style0 from "./MemcachedCacheConfig.vue?vue&type=style&index=0&id=38e084a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e084a5",
  null
  
)

export default component.exports